"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateFormats = exports.dataTypes = exports.functions = exports.bindingTypes = exports.stepTypes = exports.selectorTypes = exports.inputTypes = void 0;
var inputTypes = {
  TEXT: 'text',
  PASSWORD: 'password',
  NUMBER: 'number',
  PRIMARY_KEY: 'primaryKey'
};
exports.inputTypes = inputTypes;
var selectorTypes = {
  INPUT: 'input',
  FIND_BY_COLUMN: 'findByColumn'
};
exports.selectorTypes = selectorTypes;
var stepTypes = {
  DATABASE: 'database',
  API: 'api'
};
exports.stepTypes = stepTypes;
var bindingTypes = {
  INPUT: 'input',
  OUTPUT: 'output',
  FUNCTION: 'function',
  COLUMN: 'column',
  ARRAY_ITEM: 'arrayItem'
};
exports.bindingTypes = bindingTypes;
var functions = {
  NOW: 'now',
  BCRYPT: 'bcrypt',
  ARGON2: 'argon2',
  SHA256: 'sha256',
  UUID: 'uuid',
  RANDOM_HEX: 'randomHex',
  RANDOM_STRING: 'randomString'
};
exports.functions = functions;
var dataTypes = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  OBJECT: 'object',
  ARRAY: 'array',
  BOOLEAN: 'boolean',
  PRIMARY_KEY: 'primaryKey',
  HAS_MANY_RELATION: 'hasMany',
  // Airtable-specific types
  AIRTABLE_ATTACHMENTS: 'airtableAttachment',
  AIRTABLE_USER: 'airtableUser',
  AIRTABLE_USERS: 'airtableUsers'
};
exports.dataTypes = dataTypes;
var dateFormats = {
  SECONDS: 'seconds',
  MILLISECONDS: 'milliseconds',
  ISO: 'iso'
};
exports.dateFormats = dateFormats;